import type { ReactNode } from 'react';
import React, { useMemo, useState } from 'react';
type PaymentInfoContextType = {
  currency: string;
  donationAmount?: number | '';
  bookingStatus?: string;
  bookingResume: {
    arrivalDate: APIDate;
    proposalId?: string;
    departureDate: APIDate;
    name: string;
    transports: Array<{
      company: {
        name: string;
        id: string;
      };
      origin: string;
      destination: string;
      departure: {
        apc: string;
        date: string;
      };
      arrival: {
        apc: string;
        date: string;
      };
    }>;
    accommodations: {
      count: number;
      name?: string;
    };
  };
  redirectUri?: string | null;
  onPaymentProgress?: (location: URI) => void;
  paymentRedirectMutation: (params: PaymentRedirectMutationParams) => Promise<any>;
  trackPayment?: (arg0: any) => void;
  donationAmount?: number | '';
  isFreeDeposit?: boolean;
  isIndirectBooking?: boolean;
  isOrderedProviders?: boolean;
  isBuyNowPayLaterProcessComplete?: boolean;
  getPaymentErrorMessagePath?: (arg0: {
    errorCode?: string;
    track: (arg0: any) => void;
    isCmta?: boolean;
  }) => string;
  onBuyNowPayLaterComplete?: () => void;
  sellerOptionRedirect?: (arg0: any) => Promise<any>;
  selectedHouseholdIndex?: number;
};
// @ts-expect-error
export const PaymentInfoContext = React.createContext<PaymentInfoContextType>({
  isFreeDeposit: false,
});
export const PaymentInfoProvider = ({
  children,
  value,
}: {
  children: ReactNode;
  value: PaymentInfoContextType;
}) => {
  const [isBuyNowPayLaterProcessComplete, setIsBuyNowPayLaterProcessComplete] = useState(false);
  const [cardFeesPercentage, setCardFeesPercentage] = useState(0);
  const paymentInfoContextValue = useMemo(
    () => ({
      ...value,
      isBuyNowPayLaterProcessComplete,
      onBuyNowPayLaterComplete: () => setIsBuyNowPayLaterProcessComplete(true),
      cardFeesPercentage,
      setCardFeesPercentage,
    }),
    [value, isBuyNowPayLaterProcessComplete, cardFeesPercentage],
  );
  return (
    <PaymentInfoContext.Provider value={paymentInfoContextValue}>
      {children}
    </PaymentInfoContext.Provider>
  );
};
